import { render, staticRenderFns } from "./buy-order.vue?vue&type=template&id=0075735f&scoped=true&"
import script from "./buy-order.vue?vue&type=script&lang=js&"
export * from "./buy-order.vue?vue&type=script&lang=js&"
import style0 from "./buy-order.vue?vue&type=style&index=0&id=0075735f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075735f",
  null
  
)

export default component.exports